import * as React from "react";
const SvgStars = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.16667 13.3333V16.6666M5 3.33325V6.66659M5.83333 14.9999H2.5M6.66667 4.99992H3.33333M10.8333 3.33325L12.294 7.03689C12.4506 7.43394 12.5289 7.63247 12.6488 7.79987C12.7551 7.94825 12.885 8.07817 13.0334 8.18444C13.2008 8.30433 13.3993 8.38263 13.7964 8.53922L17.5 9.99992L13.7964 11.4606C13.3993 11.6172 13.2008 11.6955 13.0334 11.8154C12.885 11.9217 12.7551 12.0516 12.6488 12.2C12.5289 12.3674 12.4506 12.5659 12.294 12.9629L10.8333 16.6666L9.37264 12.9629C9.21604 12.5659 9.13775 12.3674 9.01786 12.2C8.91159 12.0516 8.78167 11.9217 8.63328 11.8154C8.46588 11.6955 8.26736 11.6172 7.87031 11.4606L4.16667 9.99992L7.87031 8.53922C8.26736 8.38263 8.46588 8.30433 8.63328 8.18444C8.78167 8.07817 8.91159 7.94825 9.01786 7.79987C9.13775 7.63247 9.21604 7.43394 9.37264 7.03689L10.8333 3.33325Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgStars;
